import React from 'react';
import Icon from './AppIcon';

/**
 * Permission Warning Component
 * Displays inline warnings for features restricted to officers
 */
const PermissionWarning = ({ 
  message = 'This feature is restricted to MyBodyToday officers only.',
  variant = 'default', // 'default' | 'compact' | 'banner'
  className = ''
}) => {
  const variants = {
    default: {
      container: 'bg-amber-50 border border-amber-200 rounded-lg p-4',
      icon: 'w-5 h-5 text-amber-600',
      text: 'text-sm text-amber-800'
    },
    compact: {
      container: 'bg-amber-50 border border-amber-200 rounded px-3 py-2',
      icon: 'w-4 h-4 text-amber-600',
      text: 'text-xs text-amber-800'
    },
    banner: {
      container: 'bg-amber-100 border-l-4 border-amber-500 p-4',
      icon: 'w-6 h-6 text-amber-700',
      text: 'text-sm text-amber-900 font-medium'
    }
  };

  const style = variants?.[variant] || variants?.default;

  return (
    <div className={`flex items-start gap-3 ${style?.container} ${className}`} role="alert">
      <Icon 
        name="ShieldAlert" 
        className={`flex-shrink-0 ${style?.icon}`}
        strokeWidth={2}
      />
      <div className="flex-1">
        <p className={style?.text}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default PermissionWarning;
